import { mapGetters } from "vuex";
import axios from "axios";
import { datadogRum } from "@datadog/browser-rum";
export default { 
  computed: {
    ...mapGetters({
      formData: "getFormData",
      contactId: "getContactId", 
      mainContactId: "getMainContactId",
      additionalContactId: "getAdditionalContactId",
      jwtToken: "getJwtToken",
      isMainUserGBGVerified:"isMainUserGBGVerified",
      isAdditionalUserGBGVerified:"isAdditionalUserGBGVerified"
    }),
    isGBGVerified() {
      if (this.isMainUserGBGVerified){
        if (this.additionalContactId!=null)
        {
          if (this.isAdditionalUserGBGVerified)
            return true;
          else
            return false;
        }else
          return true;
      }else
        return false;
      
    },
  },
    methods:{
        resetMessageInfo() {
            this.$store.dispatch("setMessageInfo", {
                show: false,
                message: "",
                isSuccess: false,
              });      
          },
          showGenericErrorMessage(message, success) {
            this.$store.dispatch("setMessageInfo", {
              show: true,
              message: message,
              isSuccess: success,
            });
          },
          async generateToken(contactId){
            const {data} =await axios.get(
              process.env.VUE_APP_SMT_API_URL +
                "/Client/AuthenticateUser?contactId=" +
                contactId
            );
      
            return data;
          },
          async sendCodeToMobile(contactId) {
            try{
            const { data } = await axios.post(
              process.env.VUE_APP_API_URL + "/client/GenerateAndSend2FA",
              { contactId: contactId },
              { headers: { Authorization: `Bearer ${this.jwtToken}` } }
            );
            return data;
            }catch(ex){
              console.log(ex)
            }
          },
          async sendCodeToMobileAntiSpam() {
            try{
              if (this.formData.firstName != null && this.formData.lastName != null && this.formData.mobile != null && this.formData.email != null){
            const { data } = await axios.post(
              process.env.VUE_APP_API_URL + "/client/GenerateAndSend2FAAntiSpam",
              {
                Firstname: this.formData.firstName,
                LastName: this.formData.lastName,
                MobileNumber: this.formData.mobilePrefix + this.formData.mobile,
                Email: this.formData.email,
             },
             { headers: { Authorization: `Bearer ${this.jwtToken}` } }
            );
          
            return data;
            }
            }catch(ex){
              console.log(ex)
            }
          },
          async doGBGChecks() {
            await this.gbgVerification();
          },
          async gbgVerification() {
            
            try {
              //check main user first
              const resMain = await axios.post(
                process.env.VUE_APP_API_URL + "/client/GBGVerification",
                {
                  contactId: this.contactId,
                  mainContactId: this.mainContactId,
                  sourceSite: this.formData.sourceSite,
                  isAdditionalUser: this.additionalContactId != null,
                },
                { headers: { Authorization: `Bearer ${this.jwtToken}` } }
              );
      
              this.$store.dispatch(
                "setMainUserGBGStatus",
                resMain.data.data.verificationstatus.toLowerCase()
              );
                  //debug
              // this.$store.dispatch(
              //   "setMainUserGBGStatus",
              //   "verified"
              // );
              //gbg check for sub user?
              if (this.additionalContactId != null) {
                const resSub = await axios.post(
                  process.env.VUE_APP_API_URL + "/client/GBGVerification",
                  {
                    contactId: this.additionalContactId,
                    mainContactId: this.mainContactId,
                    sourceSite: this.formData.sourceSite,
                    isAdditionalUser: false,
                  },
                  { headers: { Authorization: `Bearer ${this.jwtToken}` } }
                );
      
                this.$store.dispatch(
                  "setAdditionalUserGBGStatus",
                  resSub.data.data.verificationstatus.toLowerCase()
                );
              }
            } catch (ex) {
              console.log(ex);
            }
          },
          async createGBGLink(contactId,journeyType) {
            try{
            const { data } = await axios.post(
              process.env.VUE_APP_API_URL + `/client/CreateGBGLink?contactId=${contactId}&journeyType=${journeyType}`,
              null,
              { headers: { Authorization: `Bearer ${this.jwtToken}` } }

            );
            return data.data;
            }catch(ex){
              console.log(ex)
            }
          },
          async getIDCheckStatus(sessionId) {
            try{
            const { data } = await axios.get(
              process.env.VUE_APP_API_URL + `/client/GetIDCheckStatus?sessionId=${sessionId}`);
            return data.data;
            }catch(ex){
              console.log(ex)
            }
          },
          initDatadog(){
            datadogRum.init({
              applicationId: process.env.VUE_APP_DATADOG_APPID,
              clientToken: process.env.VUE_APP_DATADOG_TOKEN,
              site: "datadoghq.eu",
              service: "sce-form",
              env: process.env.VUE_APP_DATADOG_ENV,
              sessionSampleRate: 100,
              sessionReplaySampleRate: 100,
              trackUserInteractions: true,
              trackResources: true,
              trackLongTasks: true,
              defaultPrivacyLevel: "mask-user-input",
            });
            datadogRum.startSessionReplayRecording();
          },
          setDatadogUser(contactId, email){
            try {
            datadogRum.setUser({
              id: contactId,
              email: email,
            });
            } catch(ex) {console.log(ex)}
          }
      }
  };
  